import { DATA_SOURCE_IDS, QUERY_TYPE_IDS } from '@discover-frontend/constants';
import { getProductScope } from '@discover-frontend/utils';
import { callApi } from './api';

const sourceKeys = Object.values(DATA_SOURCE_IDS);

export const fetchFolderApi = (id, filter = 'all', pagination) => {
  const params = [];
  if (filter !== 'all') {
    params.push(`type=${filter}`);
  }

  if (pagination && pagination.page) {
    params.push(`page=${pagination.page}`, `limit=${pagination.limit}`);
  }

  params.push(`metadata=true`);
  params.push(`scope=${getProductScope()}`);

  const url = `/repository/folders/${id}?${params.join('&')}`;

  return callApi({
    api: 'WORKSPACE',
    method: 'GET',
    endpoint: url,
    mock: false,
  });
};

export const fetchRepositoryApi = ({
  mode = 'recent',
  q,
  pagination = {
    page: 1,
    limit: 20,
  },
  filters = null,
  queryType,
  parent,
  flat,
  source,
}) => {
  if (mode === QUERY_TYPE_IDS.CAMPAIGN) {
    return callApi({
      api: 'WORKSPACE',
    method: 'GET',
    endpoint: `/campaigns?scope=${getProductScope()}`,
    mock: false,
  });
  }

  const params = [];

  const hasQ = q !== undefined;

  if (q) {
    params.push(`q=${q}`);
  }

  if (mode === 'recent') {
    params.push(
      'type=audience',
      'audience_types=interest,segmentation',
      'sort_by=last_touched_date'
    );
    if (source) {
      params.push(`data_source=${source}`);
    }
  }

  if (sourceKeys.includes(mode)) {
    params.push(
      'type=audience',
      'audience_types=interest,segmentation',
      'sort_by=last_touched_date',
      `data_source=${mode}`
    );
  }

  if (mode === 'conversation') {
    params.push(
      'type=audience',
      'audience_types=conversation',
      'sort_by=last_touched_date'
    );
  }

  if (mode === 'tsv') {
    params.push(
      'type=audience',
      'audience_types=tsv',
      'sort_by=last_touched_date'
    );
  }

  if (mode === 'my') {
    params.push(
      'type=audience',
      'access=private',
      'persistence=permanent',
      `flat=${hasQ}`
    );
    if (source) {
      params.push(`data_source=${source}`);
    }
  }

  if (mode === 'template') {
    params.push('access=public', `flat=${hasQ}`);
  }

  if (mode === 'conversation-taxonomy') {
    params.push(
      'type=audience',
      'audience_types=conversation',
      'sort_by=last_touched_date',
      'persistence=permanent',
      'status=ready'
    );
  }
  if (mode === 'folders') {
    params.push('type=folder', 'access=private', 'persistence=permanent');
    params.push(`flat=${flat}`);
  }

  if (mode === 'folder-detail') {
    params.push(
      'type=audience',
      'access=private',
      'persistence=permanent',
      `flat=false`
    );

    if (source) {
      params.push(`data_source=${source}`);
    }

    if (parent) {
      params.push(`parent=${parent}`);
    }
  }

  if (mode === 'saved-queries') {
    params.push(
      'type=audience',
      'access=private',
      'persistence=permanent',
      `flat=false`,
      `data_source=${source}`
    );

    if (queryType !== '') {
      params.push(`audience_types=${queryType}`);
    } else {
      params.push('audience_types=interest,conversation');
    }

    if (parent) {
      params.push(`parent=${parent}`);
    }
  }

  if (filters) {
    if (filters.type) {
      params.push(`type=${filters.type}`);
    }
  }

  if (pagination && pagination.page) {
    params.push(`page=${pagination.page}`, `limit=${pagination.limit}`);
  }
  params.push(`scope=${getProductScope()}`);

  const url = `/repository?${params.join('&')}`;

  return callApi({
    api: 'WORKSPACE',
    method: 'GET',
    endpoint: url,
    mock: false,
  });
};

export const fetchCreateFolderApi = (body) =>
  callApi({
    api: 'WORKSPACE',
    method: 'POST',
    endpoint: `/repository/folders`,
    mock: false,
    body,
  });

export const fetchCloneAudienceApi = (id, body) =>
  callApi({
    api: 'WORKSPACE',
    method: 'POST',
    endpoint: `/repository/audiences/${id}/clone`,
    mock: false,
    body,
  });

export const fetchDeleteItemApi = (ids) =>
  callApi({
    api: 'WORKSPACE',
    method: 'DELETE',
    endpoint: `/repository?ids=${ids}&scope=${getProductScope()}`,
    mock: false,
  });

export const fetchMoveItemApi = (id, body) =>
  callApi({
    api: 'WORKSPACE',
    method: 'PUT',
    endpoint: `/repository/${id}/move`,
    body,
  });

export const fetchRenameItemApi = (id, body) => {
  return callApi({
    api: 'WORKSPACE',
    method: 'PUT',
    endpoint: `/repository/${id}/rename`,
    mock: false,
    body,
  });
};

export const fetchGetAudienceApi = (id) =>
  callApi({
    api: 'WORKSPACE',
    method: 'GET',
    endpoint: `/repository/audiences/${id}?scope=${getProductScope()}`,
    mock: false,
  });

export const fetchCreateAudienceApi = (body) =>
  callApi({
    api: 'WORKSPACE',
    method: 'POST',
    endpoint: `/repository/audiences`,
    body,
    mock: false,
  });

export const fetchSaveAudienceApi = (id, body) => {
  return callApi({
    api: 'WORKSPACE',
    method: 'PUT',
    endpoint: `/repository/audiences/${id}/save`,
    mock: false,
    body,
  });
};

export const fetchGetMembershipsApi = (ids) =>
  callApi({
    api: 'WORKSPACE',
    method: 'GET',
    endpoint: `/repository/memberships?ids=${ids}&scope=${getProductScope()}`,
    mock: false,
  });

export const fetchShareAudienceApi = (id, body) => {
  return callApi({
    api: 'WORKSPACE',
    method: 'POST',
    endpoint: `/repository/audiences/${id}/share`,
    mock: false,
    body,
  });
};
